export default __webpack_public_path__ + "img/left_chevron.12111046.svg";